import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { aiReviews } from './aiReviews';
import { auth } from './auth';
import { files } from './files';
import { funds } from './funds';
import { subscription } from './subscription';
import { users } from './users';

export const queries = mergeQueryKeys(aiReviews, auth, files, users, funds, subscription);
